import { K as KeyboardEventKey } from './p-b3de3bce.js';

class FocusIndexManager {
    /**
     * Defines keyboard keys equivalent to button press (enter, space).
     */
    static PRESS_KEYS = [
        KeyboardEventKey.Enter,
        KeyboardEventKey.SpaceBar,
    ];
    /**
     * Array of keys used to navigate horizontally
     */
    static HORIZONTAL_NAV_KEYS = [
        KeyboardEventKey.ArrowRight,
        KeyboardEventKey.ArrowLeft,
    ];
    /**
     * Array of keys used to navigate vertically
     */
    static VERTICAL_NAV_KEYS = [
        KeyboardEventKey.ArrowUp,
        KeyboardEventKey.ArrowDown,
    ];
    /**
     * Equivalent of escape on all browsers
     */
    static ESC_KEYS = [
        KeyboardEventKey.Escape,
    ];
    /**
     * Given a keyboard event, all focusable children of an element, and the index of the focused element,
     * 	calculate the index of the element that should receive keyboard focus.
     *
     * For HOME key: return index of first focusable element
     *
     * For END key: return index of last focusable element
     *
     * For UP/LEFT key: check if first focusable element focused.
     * 	If first elem focused, return index of last focusable element
     * 	Else, return index of previous focusable element
     *
     * For DOWN/RIGHT key: check if last focusable element focused.
     * 	If last elem focused, return index of first focusable element
     *	Else, return index of next focusable element
     */
    static getFocusIndexForNavEvent(focusableChildren, activeIndex, ev) {
        return focusableChildren
            ? this.getFocusIndexForNavEventAndLength(focusableChildren.length, activeIndex, ev)
            : -1;
    }
    /**
     * Given a keyboard event, length of focusable children, and active index,
     *  get index to focus next (see getFocusIndexForKeyboardEvent for full details).
     * Useful if you do not need to query for all elements.
     *
     * @param {number} length
     * @param {number} activeIndex
     * @param {KeyboardEvent} ev
     */
    static getFocusIndexForNavEventAndLength(length, activeIndex, ev) {
        switch (ev.key) {
            case KeyboardEventKey.ArrowDown:
            case KeyboardEventKey.ArrowRight: {
                // check if last header focused
                return activeIndex === length - 1 ? 0 : activeIndex + 1;
            }
            case KeyboardEventKey.ArrowUp:
            case KeyboardEventKey.ArrowLeft: {
                // check if first focused
                return activeIndex === 0 ? length - 1 : activeIndex - 1;
            }
            case KeyboardEventKey.Home: {
                return 0;
            }
            case KeyboardEventKey.End: {
                return length - 1;
            }
            default: {
                return -1;
            }
        }
    }
    /**
     * Given the index of a deleted item (e.g. tab, picklist option), and the length of
     * 	all items before deletion, return the index of the item to focus after deletion.
     */
    static getFocusIndexForDeleteEvent(deletedIndex, len) {
        let index = 0;
        if (deletedIndex - 1 > 0) {
            index = deletedIndex - 1;
        }
        if (deletedIndex + 1 < len) {
            index = deletedIndex + 1;
        }
        return index;
    }
}

export { FocusIndexManager as F };
